import React from 'react';
import { useAuth } from 'auth/context/AuthContext';
import { Roles } from '../../firebase/interfaces';
import ButtonComponent from 'components/button/buttonComponent';
import { useGetDnaTestKitWithResultByUserIdSubscription } from 'graphql/generated/hasura';
import { SCHEDULE_DNA_VISIT } from 'utilities/routes';
import { useNavigate } from 'react-router-dom';

const ScheduledDnaTest = () => {
  const navigate = useNavigate();
  return (
    <div
      className={
        'grid grid-cols-12 gap-2.5 w-full bg-white py-4 border border-t-gray-opacity-15 px-7 desktop:px-[135px]'
      }
    >
      <p className="desktop:col-span-10 col-span-full font-semibold text-neutral-800">
        Your DNA test results are ready. Schedule a DNA consultation to review
        them
      </p>
      <div className="desktop:col-span-2 col-span-full">
        <ButtonComponent
          onClick={() => navigate(SCHEDULE_DNA_VISIT, { replace: true })}
          testID="sheduled-appointment"
          className="desktop:whitespace-nowrap"
        >
          Schedule consultation
        </ButtonComponent>
      </div>
    </div>
  );
};

const ScheduledDnaTestOutlet = () => {
  const { user } = useAuth();
  const isPatient = user?.role === Roles.PATIENT;

  const { data } = useGetDnaTestKitWithResultByUserIdSubscription({
    variables: { userId: user?.uuid },
  });

  const tests = data?.tests ?? [];

  if (!isPatient) return null;

  return (
    <>
      {tests.map(() => (
        <ScheduledDnaTest />
      ))}
    </>
  );
};

export default ScheduledDnaTestOutlet;
